import { ReportTable } from 'app/components/Table';
import { EntityTypes } from 'constants/entities';
import { ReportType } from 'core/slices/report';
import { CourseVariables } from '../../Variables';
import { selectCourseProgress } from 'core/selectors/admin/courseProgress';
import { useAppSelector } from 'core/store/hooks';
import { useSelector } from 'react-redux';
import { ICourseProgressDAO } from 'types/domain/permissions';
import { variableColumns } from '../People/columns';
import { selectCourse } from 'core/selectors/admin/course';
import { ICourseDAO } from 'types/domain/course';
import { selectPortrait } from 'core/selectors/product/portrait';

export function Records() {
  const progressReports: ICourseProgressDAO[] = useSelector(selectCourseProgress);
  const courseId = useAppSelector(state => state.state[EntityTypes.COURSE]);
  const course: ICourseDAO = useAppSelector(selectCourse);
  const portrait = useAppSelector(selectPortrait);
  

  if (!courseId) return null;

  return (
    <>
      <CourseVariables />
      <ReportTable
        reportType={ReportType.COURSE_PROGRESS}
        type={EntityTypes.COURSE_PROGRESS}
        parentEntityType={EntityTypes.COURSE}
        parentEntityId={courseId}
        data={progressReports}
        paginate={true}
        columns={variableColumns(course, portrait)}
      />
    </>
  );
}
